<div class="reset-password-page">
  <header class="header">
    <h1>Stacknize</h1>
  </header>
  <div class="reset-password-container">
    <div class="image-section">
      <img src="assets/company-logo.png" alt="Company Logo" />
    </div>
    <div class="form-section">
      <h2>Reset Password</h2>
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="password">New Password</label>
          <div class="input-group">
            <input
              type="password"
              id="password"
              formControlName="password"
              placeholder="New Password"
              [ngClass]="{
                'error-border': resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched
              }"
              required
            />
            <span class="icon"><i class="fa fa-lock"></i></span>
          </div>
          <div
            class="error-message"
            *ngIf="resetPasswordForm.get('password')?.invalid && resetPasswordForm.get('password')?.touched"
          >
            Password is required and must be at least 6 characters.
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword">Confirm Password</label>
          <div class="input-group">
            <input
              type="password"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Confirm Password"
              [ngClass]="{
                'error-border': resetPasswordForm.get('confirmPassword')?.invalid && resetPasswordForm.get('confirmPassword')?.touched
              }"
              required
            />
            <span class="icon"><i class="fa fa-lock"></i></span>
          </div>
          <div
            class="error-message"
            *ngIf="resetPasswordForm.hasError('mismatch') && resetPasswordForm.get('confirmPassword')?.touched"
          >
            Passwords do not match.
          </div>
        </div>

        <button type="submit" [disabled]="resetPasswordForm.invalid">Submit</button>
      </form>
    </div>
  </div>
</div>
